import React, {Component} from 'react'
import {REASON} from "../../helpers/filterLists"
import NoteColumn from './column/NoteColumn'
import WeightColumn from './column/WeightColumn'
import DateColumn from './column/DateColumn'
import BarcodeColumn from './column/BarcodeColumn'
import StatusColumn from './column/StatusColumn'
import LabelColumn from './column/LabelColumn'
import ErrorColumn from "./column/ErrorColumn"
import PropTypes from 'prop-types'
import ProcessRequest from "./actions/ProcessRequest"
import SelectedCheckbox from "./SelectedCheckbox"

class TableRow extends Component {
    render() {
        const {item, refreshList} = this.props
        const {arrSelected, onSelected} = this.props
        const {readableStatus, changedWeightRange, barcode} = item
        const labelDetails = (barcode !== null && barcode !== undefined) ? barcode.labelDetails : {}
        const production_status = (barcode !== null && barcode !== undefined) ? barcode.production_status : ''
        const weightRange = changedWeightRange === true ? 'Có' : changedWeightRange === false ? 'Không' : ''
        const reason = REASON.find(itemReason => itemReason.value === item.reason)

        return (
            <tr className="TableRow">
                <SelectedCheckbox
                    id={item._id}
                    arrSelected={arrSelected}
                    onSelected={onSelected}
                    approvedStatus={item.approved_status}
                />
                <BarcodeColumn barcode={item.barcode_number} order={item.order_number} status={production_status}/>
                <td className="Reason">{reason.name}</td>
                <LabelColumn labelDetails={labelDetails}/>
                <WeightColumn weight={item.net_weight || 0} volume={item.net_volume || 0}/>
                <WeightColumn weight={item.setting_weight || 0} volume={item.setting_volume || 0}/>
                <StatusColumn readableStatus={readableStatus}/>
                <DateColumn created={item.created_at} generated={item.done_at || item.failed_at}/>
                <ErrorColumn error={item.error || ''}/>
                <NoteColumn id={item._id} note={item.content || ''}/>
                <td className="Change">{weightRange}</td>
                <ProcessRequest
                    id={item._id}
                    approvedStatus={item.approved_status}
                    barcodeNumber={item.barcode_number}
                    refreshList={refreshList}
                    generateStatus={item.generate_status}
                    uploadStatus={item.upload_status}
                    content={item.content || ''}
                />
            </tr>
        )
    }
}

TableRow.propTypes = {
    item: PropTypes.object
}

export default TableRow